import React, { Component, ErrorInfo, ReactNode } from 'react';

import LoadingError from 'pages/views/generic/LoadingError';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

const reactLazyErrorKeywords = ['loading', 'chunk', 'failed'];

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState | null {
    // Check if the error is related to React.lazy import failure
    if (
      reactLazyErrorKeywords.every((keyword) => error?.message?.toLowerCase()?.includes(keyword))
    ) {
      return { hasError: true };
    }

    // Do NOT update state for regular component errors (pass them through)
    return null;
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error details
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <>
          <LoadingError>Something went wrong. Try again.</LoadingError>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
